module.exports = __webpack_public_path__ + "img/vegetable-sunchokes-190x100.a1c9f268.jpg";